import _ from 'lodash';
import { QueryString } from '~/utils';
import { del, get, patch, post, put } from './agent';

const projectTasks =
  (projectTasksUrl) =>
  (id = '') => {
    const url = _([projectTasksUrl, id]).compact().join('/');

    return {
      get: (query = {}) => get(url.concat(new QueryString(query, { multi: true }).toString(true))),
      options: (query = {}) =>
        get(url.concat('/options').concat(new QueryString(query, { multi: true }).toString(true))),
      getExport: (query = {}, headers = {}) =>
        get(url.concat('/export').concat(new QueryString(query, { multi: true }).toString(true)), headers),
      history: () => get(url.concat('/history')),
      hasDependencies: () => get(url.concat('/has-dependencies')),
      role: (query = {}) => get(url.concat('/role').concat(new QueryString(query).toString(true))),
      member: (query = {}) => get(url.concat('/member').concat(new QueryString(query).toString(true))),
      upsert: (body) => (id ? patch : post)(url, body),
      delete: (query = {}) => del(url.concat(new QueryString(query).toString(true))),
      createFromTemplates: ({ ids }) => post(url.concat('/create-from-templates'), { ids }),
      clone: (body) => post(url.concat('/clone'), body),
      order: (body) => patch(url.concat('/order'), body),
      setRecordStatus: ({ recordStatusId }) => put(url.concat('/record-status'), { recordStatusId }),
      moveTime: ({ targetTaskId }) => post(url.concat('/move-time'), { targetTaskId }),
      get list() {
        const listUrl = _([projectTasksUrl, 'list', id]).compact().join('/');
        return {
          get: (query = {}) => get(listUrl.concat(new QueryString(query, { multi: true }).toString(true))),
          update: (body) => patch(listUrl, body),
        };
      },
      get board() {
        const boardUrl = _([projectTasksUrl, 'board', id]).compact().join('/');
        return {
          get: (query = {}) => get(boardUrl.concat(new QueryString(query, { multi: true }).toString(true))),
          update: (body) => patch(boardUrl, body),
        };
      },
    };
  };

export default projectTasks;
